'use client';

import React, { useState } from 'react';
import { withFullPath } from '@/utils/utils';
import withTheme from '@/theme';
import { PhotoAlbumBulkFragment } from '@/@types/generated/sitecore';
import ImagePreview, { ImagePreviewGroup } from '../ImagePreview';
import Masonry from 'react-masonry-css';

const PhotoList = (props: { content: PhotoAlbumBulkFragment }) => {
    const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
    const { albumSelection, enabled } = props.content;

    if (!enabled?.boolValue) {
        return null;
    }

    const imageList =
        albumSelection?.targetItems?.map((img, index) => ({
            src: withFullPath(img.url),
            mediaType: 'Photo',
            videoSrc: '',
            mediaCaption: '',
            id: index,
            videoOptions: {},
        })) || [];

    return withTheme(
        <ImagePreviewGroup
            imageList={imageList}
            canPreview
            total={(imageList || []).length}
            currentPreviewIndex={currentPreviewIndex}
        >
            <Masonry
                breakpointCols={{
                    default: 4,
                    1024: 3,
                    768: 1,
                    480: 1,
                }}
                className='flex gap-6'
                columnClassName='grid-item'
            >
                {imageList.map((dateItem, index) => {
                    return (
                        <div
                            className='mb-4'
                            key={dateItem.id}
                            onClick={() => {
                                setCurrentPreviewIndex(index);
                            }}
                        >
                            <ImagePreview
                                key={dateItem.id}
                                setting={{
                                    src: dateItem?.src,
                                    className: 'rounded-[5px]',
                                    rootClassName: 'w-full',
                                }}
                                mediaOption={{
                                    mediaType: dateItem.mediaType as 'Video' | 'Photo' | undefined,
                                }}
                                canPreview
                            />
                        </div>
                    );
                })}
            </Masonry>
        </ImagePreviewGroup>,
        {
            token: {
                screenMD: 991,
                screenLG: 1060,
                screenXL: 1360,
            },
        },
    );
};

export default PhotoList;
